import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAdminToken } from '../utils/storage.utils';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

/**
 * Protected Route Component
 * Admin token kontrolü yaparak yetkisiz erişimi engeller
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const adminToken = getAdminToken();

  if (!adminToken) {
    // Token yoksa login sayfasına yönlendir
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

